"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _taggedTemplateLiteral = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PhotoboothLandscape;
var _qrcode = require("qrcode.react");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _AzertyKeyboard = _interopRequireDefault(require("./AzertyKeyboard"));
var _utils = require("../utils");
var _html2canvas = _interopRequireDefault(require("html2canvas"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var pulse = (0, _styledComponents.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.15);\n  }\n  100% {\n    transform: scale(1);\n  }\n"])));

// Styled Components
var Container = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100%;\n  width: 100%;\n  position: relative;\n  overflow-y: auto;\n  box-sizing: border-box;\n"])));
var ActionButton = _styledComponents.default.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  display: block;\n  border-radius: 120px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 20rem;\n  padding: 14px 10px;\n  font-size: 1.4rem;\n  margin-top: 0.3rem;\n  text-transform: uppercase;\n  background: #FFFFFF; /* Transparent white */\n  border: none;\n  font-weight: bold;\n  box-shadow: none;\nfont-family: font;\n"])));
var ButtonGroup = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 10%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  z-index: 100;\n"])));
var SecondaryButton = (0, _styledComponents.default)(ActionButton)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 15rem;\n  padding: 14px 10px;\n  font-size: 1rem;\n  // margin-top: 1rem;\n  border-radius: 60px;\n\n  font-weight: bolf;\n  background: rgba(0,0,0,0.1);\n  border: solid 0.3em #FFFFFF;\n  box-shadow: none;\n\n  &:hover {\n  }\n"])));
var Preview = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: 2em;\n  overflow: hidden;\n  border: none;\n  margin: '0 auto';\n  border-radius: '36px';\n"])));
var PreviewWrapper = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\nposition: absolute;\nbottom: 3%;\npadding: 5em;\nwidth: 70%;\nmargin-left: -1em;\nleft: 15%;\nheight: 70%;\n// background: white;\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\njustify-content: space-between;\n/* Enforce portrait aspect ratio */\n/* margin: 20px auto; Removed margin as fixed positioning handles placement */\n// box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.1);\nz-index: 100; /* Ensure it's above other content */\n"])));
var ImageContainer = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: calc(100% - 60px);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius : 16px;\n\n  img {\n    max-width: 100%;\n    max-height: 100%;\n    // object-fit: contain; /* Preserve aspect ratio and fit inside the frame */\n    overflow: hidden;\n  }\n"])));
var ShareOptionsContainer = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 20%;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 0;\n  width: 100%;\n  max-width: 1080px;\n  z-index: 10;\n  padding: 0 1rem;\n  box-sizing: border-box;\n"])));
var ShareOptionCard = _styledComponents.default.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0;\n  border-radius: 20px;\n  backdrop-filter: blur(100px);\n  -webkit-backdrop-filter: blur(100px);\n  min-height: 235px;\n  position: relative;\n  box-sizing: border-box;\n"])));
var EmailCard = (0, _styledComponents.default)(ShareOptionCard)(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  background: rgba(122, 103, 66, 0.2);\n  width: 301px;\n  margin-right: 30px;\n"])));
var QRCodeCard = (0, _styledComponents.default)(ShareOptionCard)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  background: rgba(122, 103, 66, 0.2);\n  width: 240px;\n  margin-right: 31px;\n"])));
var PrintCard = (0, _styledComponents.default)(ShareOptionCard)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  width: 240px;\n"])));
var CardTitle = _styledComponents.default.h3(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-family: font;\n  font-size: 18px;\n  font-weight: 700;\n  text-align: center;\n  margin: 10px 0 0 0;\n  padding: 0;\n  color: ", ";\n  line-height: 1.2;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (props) {
  return props.color || '#7A6742';
});
var EmailInput = _styledComponents.default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  width: 240px;\n  height: 36px;\n  min-height: 36px;\n  flex-shrink: 0;\n  padding: 0;\n  border-radius: 100px;\n  background: rgba(255, 255, 255, 0.7);\n  font-family: font;\n  font-size: 15px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n  color: rgba(122, 103, 66, 0.5);\n  cursor: pointer;\n  margin: 12px 0 12px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n"])));
var SendButton = _styledComponents.default.button(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  width: 120px;\n  height: 36px;\n  padding: 0;\n  border-radius: 100px;\n  color: #FFFFFF;\n  font-family: font;\n  font-size: 18px;\n  font-weight: 700;\n  text-transform: uppercase;\n  border: none;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  box-sizing: border-box;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    opacity: 0.9;\n  }\n"])));
var QRCodeDisplay = _styledComponents.default.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 120px;\n  height: 120px;\n  margin: 0px auto 35px auto;\n"])));
var PrintIconContainer = _styledComponents.default.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  height: 97px;\n  margin: 32px auto 0 auto;\n"])));
var PrintButton = _styledComponents.default.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 78.75px;\n  padding: 0;\n  text-align: center;\n  font-family: font;\n  font-size: 23px;\n  font-weight: 700;\n  color: #FFFFFF;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  margin-top: 1.5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n\n  &:hover {\n    opacity: 0.9;\n  }\n\n  ", "\n"])), function (props) {
  return props.disabled && "\n    opacity: 0.6;\n    cursor: not-allowed;\n  ";
});
var ShareFormContainer = _styledComponents.default.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 65%;\n  flex-direction: column;\n  align-items: center;\n  padding: 1rem;\n  z-index: 10;\n  border-radius: 24px;\n  background:rgb(255, 255, 255, 0.2);\n  opacity: 0.4;\n  backdrop-filter: blur(20px);\n"])));
var ShareContent = _styledComponents.default.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr 10rem;\n  gap: 0.5rem;\n  align-items: start;\n"])));
var FormTitle = _styledComponents.default.h2(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  font-family: font;\n  font-size: 0.9rem;\n  font-weight: 500;\n  margin: 1rem 0;\n  text-align: center;\n  width: 100%;\n  font-weight: bold;\n  font-family: font;\n  color : #fff;\n"])));
var QRCodeWrapper = _styledComponents.default.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  margin-left: 3rem;\n  background: white;\n  padding: 0.5rem;\n  border-radius: 0.8rem;\n  width: 5rem;\n"])));
var PreviewWrapper2 = _styledComponents.default.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  bottom: 9em;\n  transform: translateX(-50%);\n  width: 90%;\n  padding: 1em;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  z-index: 100;\n"])));
var ShareInput = _styledComponents.default.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  padding: 0.7rem 1rem;\n  border-radius: 2rem;\n  font-size: 1rem;\n  font-family: font;\n  outline: none;\n  border: none;\n  background: #FFFFFF;\n  border: 0.1rem solid #000000;\n  &:focus {\n  }\n"])));
var ShareCheckbox = _styledComponents.default.label(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  font-family: font;\n  font-size: 0.8rem;\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  line-height: 1.4;\n\n  input {\n    width: 1rem;\n    height: 1rem;\n\n  }\n  input[type=\"checkbox\"]:checked {\n  background-color: #333;\n}\n"])));
var BackgroundWrapper = _styledComponents.default.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  background-size: cover;\n  background: rgba(0,0,0,0);\n  background-position: center;\n  width: 100%;\n  height: 100%;\n"])));
var ShareButton = (0, _styledComponents.default)(ActionButton)(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  margin: 0;\n  width: 40%;\n  border-radius: 2rem;\n  font-size: 1rem;\n  padding: 0.5rem;\n  text-transform: none;\n  background: #FFFFFF;\n  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(12.5px);\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n"])));
var LogoImage = _styledComponents.default.img(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  height: auto;\n  width: 30%;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n"])));
var LogoImage2 = _styledComponents.default.img(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  height: auto;\n  width: 90%;\n  margin-top: 0.7rem;\n"])));
var ShareForm = _styledComponents.default.form(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n"])));
var CameraContainer = _styledComponents.default.div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  ", "\n  top: 3rem;\n  position: relative;\n  border-radius: 0px;\n  overflow: hidden;\n  box-sizing: border-box;\n  background: ", "; /* Fond blanc tant que la cam\xE9ra n\u2019est pas pr\xEAte */\n"])), function (props) {
  return props.aspectRatio ? "\n    width: calc(100% - 2rem);\n    max-height: calc(100% - 2rem);\n    aspect-ratio: ".concat(props.aspectRatio, ";\n    margin: auto;\n  ") : props.orientation === 'landscape' ? "\n    width: calc(100% - 2rem);\n    max-height: calc(100% - 2rem);\n    aspect-ratio: 16 / 9;\n    margin: auto;\n  " : "\n    width: calc(100% - 2rem);\n    height: 100%;\n    margin: 0 1rem;\n  ";
}, function (props) {
  return props.cameraReady ? 'transparent' : '#737373';
});
var Camera = _styledComponents.default.div(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: relative;\n"])));
var BackgroundVideoPreview = _styledComponents.default.video(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 8rem;\n  left: 0;\n  width: 100%;\n  height: 85%;\n  object-fit: cover;\n  transform: rotate(0deg) scale(0.85);\n  transform-origin: center center;\n  filter: blur(20px);\n  clip-path: inset(0);\n  z-index: 0;\n  pointer-events: none;\n"])));
var VideoPreview = _styledComponents.default.video(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: ", ";\n  height: calc(90% - 4px);\n  object-fit: ", ";\n  object-position: center top;\n  transform: ", ";\n  transform-origin: center center;\n  border-radius: 2.2em;\n"])), function (props) {
  return props.orientation === 'landscape' ? 'calc(90% - 4px)' : 'calc(110% - 4px)';
}, function (props) {
  return props.orientation === 'landscape' ? 'cover' : 'contain';
}, function (props) {
  var center = 'translate(-50%, -50%)';
  if (props.orientation === 'landscape') {
    return props.mirror ? "".concat(center, " scaleX(-1)") : center;
  }
  return props.mirror ? "".concat(center, " scaleX(-1) rotate(90deg) scale(1.57) translateY(-10px)") : "".concat(center, " rotate(90deg) scale(1.57)");
});

// COMMENTED OUT: Frozen frame feature (may be needed later)
// const FrozenFrame = styled.img`
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
//   /* Rotate 90° and scale to fill container (scale by container aspect ratio to compensate for rotation) */
//   transform: scaleX(-1) rotate(90deg) scale(1.57); // Mirror effect + 90° rotation like video
//   transform-origin: center center;
//   border-radius: 2.2em;
//   position: absolute;
//   top: 0;
//   left: 0;
//   z-index: 1;
// `;

// const ProcessingOverlay = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   background: rgba(0, 0, 0, 0.3);
//   backdrop-filter: blur(2px);
//   z-index: 100;
//   border-radius: 2.2em;
// `;

// const ProcessingMessage = styled.div`
//   font-family: 'Helvetica Neue', sans-serif;
//   font-size: 1.5rem;
//   font-weight: 600;
//   color: white;
//   text-align: center;
//   padding: 1rem 2rem;
//   background: rgba(0, 0, 0, 0.6);
//   border-radius: 1rem;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
//   backdrop-filter: blur(10px);
// `;

var CountdownOverlay = _styledComponents.default.div(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 4rem;\n  height: 4rem;\n  background: rgba(255, 255, 255, 0.5);\n  box-shadow: 10px 15px 30px rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n"])));
var CountdownNumber = _styledComponents.default.div(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  font-family: font;\n  font-size: 1.8rem;\n  font-weight: 700;\n  line-height: 1;\n"])));

// Progress bar container: Shows below camera loader when photo is being processed
var ProgressBarContainer = _styledComponents.default.div(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 60%;\n  max-width: 20rem;\n  z-index: 100;\n"])));
var ProgressBarWrapper = _styledComponents.default.div(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 0.5rem;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 0.5rem;\n  overflow: hidden;\n  margin-top: 15px;\n  position: relative;\n"])));
var ProgressBarFill = _styledComponents.default.div(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: ", "%;\n  background: #fff;\n  background-size: 1rem 1rem;\n  animation: progressAnimation 0.5s linear infinite;\n  transition: width 0.3s ease-out;\n\n  @keyframes progressAnimation {\n    0% {\n      background-position: 0 0;\n    }\n    100% {\n      background-position: 1rem 1rem;\n    }\n  }\n"])), function (props) {
  return props.progress;
});
var ProgressText = _styledComponents.default.div(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  margin-top: 0.5rem;\n  text-align: center;\n  font-family: font;\n  font-size: 1rem;\n  font-weight: 600;\n  color: white;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);\n"])));
var GifOverlay = _styledComponents.default.img(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90%;\n  height: 90%;\n  object-fit: contain;\n  z-index: 50;\n  pointer-events: none;\n"])));

// COMMENTED OUT: Flash animation feature (may be needed later)
// Flash overlay: Full-screen white flash animation that appears when photo is taken
// Shows for 500ms to simulate camera flash effect
// const FlashOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100vw;
//   height: 100vh;
//   background-color: white;
//   z-index: 10000; // High z-index to cover everything
//   pointer-events: none; // Don't block user interactions
//   opacity: ${props => props.show ? 1 : 0};
//   transition: opacity 0.1s ease-out; // Smooth fade transition
// `;

var ControlBar = _styledComponents.default.div(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* center items horizontally */\n  justify-content: center;\n  position: absolute;\n  top: 25%;\n  z-index: 60;\n  width: 100%;\n"])));

/* Sits above the camera box; instructions/countdown render here so they are
   not clipped by the camera container's overflow: hidden. */
var TopOverlay = _styledComponents.default.div(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 15%;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  z-index: 16000;\n"])));
var CameraButton = _styledComponents.default.div(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n    padding: 0;\n    background: none;\n    border: none;\n    border-radius: 0;\n    box-shadow: none;\n    backdrop-filter: none;\n    -webkit-backdrop-filter: none;\n    cursor: pointer;\n\n"])));
var ButtonText = _styledComponents.default.div(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  font-family: font;\n  font-size: 1.2em;\n  font-weight: 500;\n  letter-spacing: 1px;\n  margin-top: 1rem;\n  animation: ", " 1.2s ease-in-out infinite;\n"])), pulse);
function PhotoboothLandscape(_ref4) {
  var cell = _ref4.cell,
    pageId = _ref4.pageId,
    screenType = _ref4.screenType,
    _ref4$uriTransformer = _ref4.uriTransformer,
    uriTransformer = _ref4$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref4$uriTransformer,
    project = _ref4.project,
    intl = _ref4.intl,
    defaultLanguage = _ref4.defaultLanguage;
  var _ref5 = (0, _react.useState)(''),
    _ref6 = _slicedToArray(_ref5, 2),
    email = _ref6[0],
    setEmail = _ref6[1];
  var _ref7 = (0, _react.useState)({}),
    _ref8 = _slicedToArray(_ref7, 2),
    textDatas = _ref8[0],
    setTextDatas = _ref8[1];
  var _ref9 = (0, _react.useState)(false),
    _ref0 = _slicedToArray(_ref9, 2),
    consent = _ref0[0],
    setConsent = _ref0[1];
  var _ref1 = (0, _react.useState)(true),
    _ref10 = _slicedToArray(_ref1, 2),
    terms = _ref10[0],
    setTerms = _ref10[1];
  var _ref11 = (0, _react.useState)(''),
    _ref12 = _slicedToArray(_ref11, 2),
    link = _ref12[0],
    setLink = _ref12[1];
  var _ref13 = (0, _react.useState)(false),
    _ref14 = _slicedToArray(_ref13, 2),
    isSending = _ref14[0],
    setIsSending = _ref14[1];
  var _ref15 = (0, _react.useState)(null),
    _ref16 = _slicedToArray(_ref15, 2),
    sendStatus = _ref16[0],
    setSendStatus = _ref16[1];
  var _ref17 = (0, _react.useState)('camera'),
    _ref18 = _slicedToArray(_ref17, 2),
    step = _ref18[0],
    setStep = _ref18[1];
  var _ref19 = (0, _react.useState)(null),
    _ref20 = _slicedToArray(_ref19, 2),
    capturedImage = _ref20[0],
    setCapturedImage = _ref20[1];
  var _ref21 = (0, _react.useState)(5),
    _ref22 = _slicedToArray(_ref21, 2),
    countdown = _ref22[0],
    setCountdown = _ref22[1];
  var streamRef = (0, _react.useRef)(null);
  var previewCanvasRef = (0, _react.useRef)(null);
  var animationFrameId = (0, _react.useRef)(null);
  var _ref23 = (0, _react.useState)(false),
    _ref24 = _slicedToArray(_ref23, 2),
    hasCamera = _ref24[0],
    setHasCamera = _ref24[1];
  var _ref25 = (0, _react.useState)(null),
    _ref26 = _slicedToArray(_ref25, 2),
    cameraError = _ref26[0],
    setCameraError = _ref26[1];
  var videoRef = (0, _react.useRef)(null);
  var backgroundVideoRef = (0, _react.useRef)(null);
  var cameraContainerRef = (0, _react.useRef)(null);
  var progressIntervalRef = (0, _react.useRef)(null); // Store progress interval reference
  var _ref27 = (0, _react.useState)(false),
    _ref28 = _slicedToArray(_ref27, 2),
    keyboardVisible = _ref28[0],
    setKeyboardVisible = _ref28[1];
  var _ref29 = (0, _react.useState)(false),
    _ref30 = _slicedToArray(_ref29, 2),
    isSended = _ref30[0],
    setIsSended = _ref30[1];
  var _ref31 = (0, _react.useState)(false),
    _ref32 = _slicedToArray(_ref31, 2),
    printed = _ref32[0],
    setPrinted = _ref32[1];
  var _ref33 = (0, _react.useState)(null),
    _ref34 = _slicedToArray(_ref33, 2),
    imageUrl = _ref34[0],
    setImageUrl = _ref34[1];
  var _ref35 = (0, _react.useState)(''),
    _ref36 = _slicedToArray(_ref35, 2),
    font = _ref36[0],
    setFont = _ref36[1];
  var _ref37 = (0, _react.useState)(false),
    _ref38 = _slicedToArray(_ref37, 2),
    isProcessing = _ref38[0],
    setIsProcessing = _ref38[1]; // Track when photo is being processed (camera loader visible)
  var _ref39 = (0, _react.useState)(0),
    _ref40 = _slicedToArray(_ref39, 2),
    processingProgress = _ref40[0],
    setProcessingProgress = _ref40[1]; // Track processing progress (0-100)
  var _ref41 = (0, _react.useState)(false),
    _ref42 = _slicedToArray(_ref41, 2),
    showImage = _ref42[0],
    setShowImage = _ref42[1];
  var _ref43 = (0, _react.useState)(false),
    _ref44 = _slicedToArray(_ref43, 2),
    showEmail = _ref44[0],
    setShowEmail = _ref44[1];
  var _ref45 = (0, _react.useState)(false),
    _ref46 = _slicedToArray(_ref45, 2),
    showQRCode = _ref46[0],
    setShowQRCode = _ref46[1];
  var _ref47 = (0, _react.useState)(false),
    _ref48 = _slicedToArray(_ref47, 2),
    showPrint = _ref48[0],
    setShowPrint = _ref48[1];
  var _ref49 = (0, _react.useState)(null),
    _ref50 = _slicedToArray(_ref49, 2),
    capturedPreview = _ref50[0],
    setCapturedPreview = _ref50[1];
  var _ref51 = (0, _react.useState)(null),
    _ref52 = _slicedToArray(_ref51, 2),
    shareImage = _ref52[0],
    setShareImage = _ref52[1];
  var emailCardRef = (0, _react.useRef)(null);
  var _ref53 = (0, _react.useState)(textDatas.print),
    _ref54 = _slicedToArray(_ref53, 2),
    printButtonText = _ref54[0],
    setPrintButtonText = _ref54[1];
  var _ref55 = (0, _react.useState)(null),
    _ref56 = _slicedToArray(_ref55, 2),
    filterAspect = _ref56[0],
    setFilterAspect = _ref56[1];
  var gpios = [0, 4, 17, 22, 27];
  (0, _react.useEffect)(function () {
    if (step === 'share') {
      gpios.forEach(function (gpio) {
        console.log("treeosk-btn-" + gpio);
      });

      // reset visibility
      setShowImage(false);
      setShowEmail(false);
      setShowQRCode(false);
      setShowPrint(false);

      // Déclenchements séquentiels
      setTimeout(function () {
        return setShowImage(true);
      }, 0);
      setTimeout(function () {
        return setShowEmail(true);
      }, 500);
      setTimeout(function () {
        return setShowQRCode(true);
      }, 1000);
      setTimeout(function () {
        return setShowPrint(true);
      }, 1500);
    }
  }, [step]);

  // COMMENTED OUT: Flash and frozen frame states (may be needed later)
  // const [showFlash, setShowFlash] = useState(false); // Controls flash animation visibility
  // const [frozenFrame, setFrozenFrame] = useState(null); // Frozen frame image after photo capture

  var gif_uri = (0, _utils.i18nData)(cell, 'gif_uri', intl, defaultLanguage) || 'https://web-treeosk.online/apks/anim_cadre.gif';
  var gif_uri_transformed = uriTransformer(gif_uri);
  var gif_uri2 = (0, _utils.i18nData)(cell, 'gif_uri', intl, defaultLanguage) || 'https://web-treeosk.online/apks/fifth_frame.png';
  var gif_uri_transformed2 = uriTransformer(gif_uri2);
  (0, _react.useEffect)(function () {
    if (!gif_uri_transformed) {
      setFilterAspect(null);
      return;
    }
    // No crossOrigin here: we only read naturalWidth/Height (no canvas pixel
    // access), and requiring CORS would make the load fail when the filter is
    // served without CORS headers — leaving filterAspect null and the video
    // bleeding past a non-16:9 filter.
    var img = new Image();
    img.onload = function () {
      if (img.naturalWidth && img.naturalHeight) {
        setFilterAspect(img.naturalWidth / img.naturalHeight);
      }
    };
    img.onerror = function () {
      return setFilterAspect(null);
    };
    img.src = gif_uri_transformed;
  }, [gif_uri_transformed]);

  // 1. Camera constraints: always 16:9 horizontal
  var VIDEO_WIDTH = 1920;
  var VIDEO_HEIGHT = 1080; // 16:9

  // 2. Capture: crop to 6:4 (horizontal), then rotate to portrait (4:6)
  var CROP_WIDTH = 1200; // 6:4 from 1080 height: 1080 * 1.5 = 1620
  var CROP_HEIGHT = 800; // same as video height

  var ROTATED_WIDTH = CROP_HEIGHT; // 1080 (portrait width)
  var ROTATED_HEIGHT = CROP_WIDTH; // 1620 (portrait height)

  var handleVisibilityChange = function handleVisibilityChange() {
    if (document.visibilityState === 'visible' && (step === 'camera' || step === 'countdown')) {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(function (track) {
          return track.stop();
        });
        streamRef.current = null;
      }
      if (videoRef.current) {
        videoRef.current.srcObject = null;
      }
      setTimeout(function () {
        _initializeCamera();
      }, 300);
    }
  };
  (0, _react.useEffect)(function () {
    if (step === 'camera') {
      _initializeCamera();
      document.addEventListener('visibilitychange', handleVisibilityChange);
    }
    return function () {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (step !== 'camera' && step !== 'countdown') {
        if (animationFrameId.current) {
          cancelAnimationFrame(animationFrameId.current);
          animationFrameId.current = null;
        }
        if (streamRef.current) {
          streamRef.current.getTracks().forEach(function (track) {
            track.stop();
          });
          streamRef.current = null;
        }
        if (videoRef.current) {
          videoRef.current.srcObject = null;
        }
        setHasCamera(false);
      }
    };
  }, [step]);

  // Pause video feed when processing (UI only - doesn't affect backend)
  (0, _react.useEffect)(function () {
    if (isProcessing && videoRef.current) {
      videoRef.current.pause();
    } else if (!isProcessing && videoRef.current && hasCamera && step === 'camera') {
      // Resume video if we're back to camera step and not processing
      videoRef.current.play().catch(function (e) {
        console.warn('Could not resume video:', e);
      });
    }
  }, [isProcessing, hasCamera, step]);

  // Automatically generate QR code when step becomes 'share' and image is captured
  (0, _react.useEffect)(function () {
    if (step === 'share' && capturedImage && !link && !isSending && cell.qr_code) {
      // Automatically trigger share to generate QR code/link
      handleShare();
    }
  }, [step, capturedImage, link, isSending, cell.qr_code]);
  (0, _react.useEffect)(function () {
    if (project) {
      setFont(project.default_button_font);
    }
  }, []);
  // Helper: Find camera deviceId by label substring
  function getCameraDeviceIdByLabel(_x) {
    return _getCameraDeviceIdByLabel.apply(this, arguments);
  } // Update initializeCamera to use the helper
  function _getCameraDeviceIdByLabel() {
    _getCameraDeviceIdByLabel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(labelSubstring) {
      var devices, cameras, match;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return navigator.mediaDevices.enumerateDevices();
          case 1:
            devices = _context.v;
            // Only available after user has granted camera access at least once
            cameras = devices.filter(function (d) {
              return d.kind === 'videoinput';
            }); // Try to find a camera whose label includes the substring (case-insensitive)
            match = cameras.find(function (cam) {
              return cam.label && cam.label.toLowerCase().includes(labelSubstring.toLowerCase());
            });
            return _context.a(2, match ? match.deviceId : cameras[0] ? cameras[0].deviceId : null);
        }
      }, _callee);
    }));
    return _getCameraDeviceIdByLabel.apply(this, arguments);
  }
  var _initializeCamera = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var labelSubstring, deviceId, constraints, stream, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (animationFrameId.current) {
              cancelAnimationFrame(animationFrameId.current);
              animationFrameId.current = null;
            }
            if (streamRef.current) {
              streamRef.current.getTracks().forEach(function (track) {
                return track.stop();
              });
              streamRef.current = null;
            }
            if (videoRef.current) {
              videoRef.current.srcObject = null;
            }
            _context2.p = 1;
            // Choose the relevant camera by label substring (e.g., "logitech" or your camera's name)
            labelSubstring = cell.cameralabel; // <-- Change this to match your camera label
            console.log({
              cell: cell
            });
            _context2.n = 2;
            return getCameraDeviceIdByLabel(labelSubstring);
          case 2:
            deviceId = _context2.v;
            constraints = {
              video: {
                width: {
                  ideal: VIDEO_WIDTH
                },
                height: {
                  ideal: VIDEO_HEIGHT
                },
                facingMode: 'user',
                deviceId: deviceId ? {
                  exact: deviceId
                } : undefined
              },
              audio: false
            };
            _context2.n = 3;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 300);
            });
          case 3:
            _context2.n = 4;
            return navigator.mediaDevices.getUserMedia(constraints);
          case 4:
            stream = _context2.v;
            if (videoRef.current) {
              videoRef.current.srcObject = stream;
              videoRef.current.onloadedmetadata = function () {
                videoRef.current.play().then(function () {
                  setHasCamera(true);
                  setCameraError(null);
                }).catch(function (e) {
                  setCameraError(e.message);
                });
              };
              streamRef.current = stream;
            }
            if (backgroundVideoRef.current) {
              backgroundVideoRef.current.srcObject = stream;
              backgroundVideoRef.current.play().catch(function () {});
            }
            _context2.n = 6;
            break;
          case 5:
            _context2.p = 5;
            _t2 = _context2.v;
            setCameraError(_t2.message);
            setHasCamera(false);
            if (step === 'camera' || step === 'countdown') {
              setTimeout(function () {
                _initializeCamera();
              }, 1000);
            }
          case 6:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 5]]);
    }));
    return function initializeCamera() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleTakePhoto = function handleTakePhoto() {
    if (step === 'camera' && hasCamera) {
      setStep('countdown');
      startCountdown();
    }
  };

  // COMMENTED OUT: Frozen frame capture function (may be needed later)
  // Capture frozen frame from video to show while processing
  // const captureFrozenFrame = () => {
  //   if (!videoRef.current) return null;
  //
  //   const video = videoRef.current;
  //   // Check if video is ready
  //   if (video.videoWidth === 0 || video.videoHeight === 0) {
  //     return null;
  //   }

  //   const canvas = document.createElement('canvas');
  //   // Rotate 90°: swap width and height
  //   canvas.width = video.videoHeight;
  //   canvas.height = video.videoWidth;
  //   const ctx = canvas.getContext('2d');
  //
  //   // Rotate 90° clockwise and apply mirror effect to match video display
  //   ctx.translate(canvas.width, 0);
  //   ctx.rotate(Math.PI / 2); // 90° clockwise
  //   ctx.scale(-1, 1); // Mirror effect
  //   ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
  //
  //   return canvas.toDataURL('image/jpeg', 0.9);
  // };

  var startCountdown = function startCountdown() {
    setCountdown(5);
    var countdownInterval = setInterval(function () {
      setCountdown(function (prev) {
        if (prev <= 0) {
          clearInterval(countdownInterval);
          // When countdown reaches 0, show camera loader and pause video feed (UI only)
          setIsProcessing(true);
          setProcessingProgress(0); // Reset progress
          // Pause video feed immediately when processing starts (UI only - doesn't affect backend)
          if (videoRef.current) {
            videoRef.current.pause();
          }

          // Start progress animation - increments from 0% to 90% gradually
          // Progress will jump to 100% when actual photo processing completes
          var progress = 0;
          progressIntervalRef.current = setInterval(function () {
            progress += 2; // Increment by 2% every ~200ms
            if (progress >= 90) {
              progress = 90; // Cap at 90% until actual processing completes
            }
            setProcessingProgress(progress);
          }, 200);

          // Capture photo (runs in background while video is paused in UI)
          capturePhoto();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  function printImageData(imageDataUrl) {
    if (printed) return;
    if (window.electronAPI) {
      window.electronAPI.sendImageForPrint(imageDataUrl);
    }
    if (window.Android && typeof window.Android.postMessage === 'function') {
      window.Android.postMessage(imageDataUrl);
    }
    setPrinted(true);
  }
  var fallbackCapturePhoto = function fallbackCapturePhoto() {
    if (!videoRef.current || !previewCanvasRef.current) {
      console.error('❌ Video or canvas not available');
      return;
    }
    var canvas = previewCanvasRef.current;
    var context = canvas.getContext('2d');
    var video = videoRef.current;

    // Check if video is ready
    if (video.videoWidth === 0 || video.videoHeight === 0) {
      console.error('❌ Video not ready');
      // COMMENTED OUT: Frozen frame state reset (may be needed later)
      // setIsProcessing(false);
      // setFrozenFrame(null);
      return;
    }
    // 1. Crop center 6:4 region from 16:9 video
    // Ensure crop dimensions do not exceed actual video size to avoid negative source dimensions
    var sWidth = Math.min(CROP_WIDTH, video.videoWidth);
    var sHeight = Math.min(CROP_HEIGHT, video.videoHeight);
    var sx = Math.max(0, Math.floor((video.videoWidth - sWidth) / 2));
    var sy = Math.max(0, Math.floor((video.videoHeight - sHeight) / 2));
    var targetWidth = sWidth;
    var targetHeight = sHeight;

    // 2. Prepare canvas for portrait (rotated) output
    canvas.width = ROTATED_WIDTH; // 1080
    canvas.height = ROTATED_HEIGHT; // 1620

    var gifImg = new Image(targetWidth, targetHeight);
    gifImg.style.backgroundColor = 'white';
    gifImg.style.width = '100%';
    gifImg.style.height = '100%';
    gifImg.style.objectFit = 'cover';
    gifImg.style.objectPosition = 'center';
    gifImg.height = targetHeight;
    gifImg.width = targetWidth;
    gifImg.style.backgroundSize = 'cover';
    gifImg.crossOrigin = 'Anonymous';

    // Add timeout to prevent infinite waiting
    var timeoutId = setTimeout(function () {
      console.warn('⚠️ GIF image load timeout, proceeding without GIF overlay');
      // Proceed with photo capture even if GIF fails to load
      processPhotoCapture(context, canvas, video, targetWidth, targetHeight, null);
    }, 10000); // 10 second timeout

    gifImg.onload = function () {
      clearTimeout(timeoutId);
      console.log(gifImg);
      processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, gifImg);
    };
    gifImg.onerror = function (error) {
      clearTimeout(timeoutId);
      console.error('❌ Error loading GIF overlay:', error);
      // Proceed with photo capture even if GIF fails to load
      processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, null);
    };
    gifImg.src = gif_uri_transformed2;
  };

  // Draws the video frame onto a canvas using cover-fit, with optional 90° rotation for portrait.
  var drawVideoCover = function drawVideoCover(ctx, targetW, targetH, video, sx, sy, sWidth, sHeight, isLandscape) {
    ctx.clearRect(0, 0, targetW, targetH);
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, targetW, targetH);
    ctx.save();
    var videoAspect = sWidth / sHeight;
    var drawW, drawH;
    if (isLandscape) {
      var canvasAspect = targetW / targetH;
      if (videoAspect > canvasAspect) {
        drawH = targetH;
        drawW = targetH * videoAspect;
      } else {
        drawW = targetW;
        drawH = targetW / videoAspect;
      }
      ctx.drawImage(video, sx, sy, sWidth, sHeight, (targetW - drawW) / 2, (targetH - drawH) / 2, drawW, drawH);
    } else {
      ctx.translate(targetW / 2, targetH / 2);
      ctx.rotate(Math.PI / 2);
      var _canvasAspect = targetH / targetW;
      if (videoAspect > _canvasAspect) {
        drawH = targetW;
        drawW = targetW * videoAspect;
      } else {
        drawW = targetH;
        drawH = targetH / videoAspect;
      }
      ctx.drawImage(video, sx, sy, sWidth, sHeight, -drawW / 2, -drawH / 2, drawW, drawH);
    }
    ctx.restore();
  };

  // Helper function to process photo capture
  var processPhotoCapture = function processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, gifImg) {
    try {
      var isLandscape = cell.orientation === 'landscape';
      // 300 DPI for 10.6cm x 15.24cm print: 10.6/2.54*300 ≈ 1252, 15.24/2.54*300 = 1800
      var finalW = isLandscape ? 1800 : 1252;
      var finalH = isLandscape ? 1252 : 1800;
      canvas.width = finalW;
      canvas.height = finalH;

      // --- Preview canvas ---
      var previewCanvas = document.createElement('canvas');
      previewCanvas.width = isLandscape ? 600 : 400;
      previewCanvas.height = isLandscape ? 400 : 600;
      var previewCtx = previewCanvas.getContext('2d');
      drawVideoCover(previewCtx, previewCanvas.width, previewCanvas.height, video, sx, sy, sWidth, sHeight, isLandscape);
      var previewData = previewCanvas.toDataURL('image/png');
      setCapturedPreview(previewData);

      // --- Share canvas (with GIF overlay) ---
      var shareCanvas = document.createElement('canvas');
      shareCanvas.width = finalW;
      shareCanvas.height = finalH;
      var shareCtx = shareCanvas.getContext('2d');
      drawVideoCover(shareCtx, finalW, finalH, video, sx, sy, sWidth, sHeight, isLandscape);
      if (gifImg) {
        shareCtx.drawImage(gifImg, 0, 0, finalW, finalH);
      }
      var shareData = shareCanvas.toDataURL('image/png');
      setShareImage(shareData);

      // --- Main canvas (for printing) ---
      drawVideoCover(context, finalW, finalH, video, sx, sy, sWidth, sHeight, isLandscape);
      if (gifImg) {
        context.drawImage(gifImg, 0, 0, finalW, finalH);
      }
      var imageData = canvas.toDataURL('image/png');
      setCapturedImage(imageData);
      if (progressIntervalRef.current) clearInterval(progressIntervalRef.current);
      setProcessingProgress(100);
      setTimeout(function () {
        setIsProcessing(false);
        setProcessingProgress(0);
        setStep('share');
      }, 300);
    } catch (error) {
      console.error('❌ Error processing photo capture:', error);
      if (progressIntervalRef.current) clearInterval(progressIntervalRef.current);
      setIsProcessing(false);
      setProcessingProgress(0);
    }
  };
  var capturePhoto = function capturePhoto() {
    fallbackCapturePhoto(); // Always use fallback to ensure GIF is drawn
    // console.log('treeosk-btn-' + cell.gpio_number);
  };
  var handleRetake = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            setCapturedImage(null);
            setLink(''); // Reset link so it can be regenerated for new photo
            setIsSended(false); // Reset email sent status
            setPrinted(false);
            setPrintButtonText(textDatas.print);
            // Clear progress interval if still running
            if (progressIntervalRef.current) {
              clearInterval(progressIntervalRef.current);
              progressIntervalRef.current = null;
            }
            setIsProcessing(false); // Reset processing state
            setProcessingProgress(0); // Reset progress

            // Clean up existing camera stream
            if (streamRef.current) {
              streamRef.current.getTracks().forEach(function (track) {
                return track.stop();
              });
              streamRef.current = null;
            }
            if (videoRef.current) {
              videoRef.current.srcObject = null;
            }
            setHasCamera(false);
            setStep('camera');
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function handleRetake() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleShare = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
      var img, imageData, response, record, _t3;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            if (e) {
              e.preventDefault();
            }
            setSendStatus(null);
            _context4.p = 1;
            if (!(email && !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/.test(email))) {
              _context4.n = 2;
              break;
            }
            throw new Error('Invalid email address');
          case 2:
            if (shareImage) {
              _context4.n = 3;
              break;
            }
            throw new Error('No captured image available');
          case 3:
            // Set sending state only after we start the actual upload
            setIsSending(true);

            // Use the original high-resolution capturedImage (2160x3240px) for digital/QR code
            // Convert PNG to high-quality JPEG to reduce file size while maintaining quality
            img = new Image();
            img.crossOrigin = 'anonymous';
            _context4.n = 4;
            return new Promise(function (resolve, reject) {
              img.onload = function () {
                // Create a canvas matching the loaded image natural size to avoid any squash/stretch
                var naturalW = img.naturalWidth || img.width;
                var naturalH = img.naturalHeight || img.height;
                var canvas = document.createElement('canvas');
                canvas.width = naturalW;
                canvas.height = naturalH;
                var ctx = canvas.getContext('2d');

                // Draw the image at its natural size
                ctx.drawImage(img, 0, 0, naturalW, naturalH);

                // Convert to high-quality JPEG (0.95 quality for good balance between size and quality)
                var jpegData = canvas.toDataURL('image/jpeg', 0.95);
                resolve(jpegData);
              };
              img.onerror = reject;
              img.src = shareImage;
            });
          case 4:
            imageData = _context4.v;
            setImageUrl(imageData);
            _context4.n = 5;
            return fetch("".concat(project.backEndUri, "/send_photo"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                cell_id: cell.id,
                image: imageData,
                // Utiliser l'image capturée
                email: email,
                consent: consent,
                terms: terms,
                project_id: project.id
              })
            });
          case 5:
            response = _context4.v;
            if (response.ok) {
              _context4.n = 6;
              break;
            }
            throw new Error('Upload failed');
          case 6:
            _context4.n = 7;
            return response.json();
          case 7:
            record = _context4.v;
            setSendStatus('success');
            setLink(record.image_uri);
            setEmail('');
            setConsent(false);
            if (email) {
              setIsSended(true);
            }

            // Only set isSending to false after link is set and QR code can render
            setIsSending(false);
            _context4.n = 9;
            break;
          case 8:
            _context4.p = 8;
            _t3 = _context4.v;
            setSendStatus('error: ' + _t3);
            setIsSending(false);
          case 9:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 8]]);
    }));
    return function handleShare(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    switch (intl.locale) {
      case 'fr':
        setTextDatas({
          description: 'Recevoir la photo par email ou scanner le QR-code.',
          buttonDownload: 'Télécharger la photo',
          buttonRetake: 'Retake the picture',
          buttonTake: 'Appuyer pour commencer',
          send: 'Envoyer',
          sendByEmail: 'Envoyer par mail',
          // <-- ajouté
          conditions: 'J\'accepte de recevoir la photo sur mon adresse email',
          conditions2: 'J\'ai lu et j\'accepte les termes et conditions.',
          sent: 'Photo envoyée !',
          look: 'Regardez la caméra',
          preparingPhoto: 'Préparation de la photo...',
          almostThere: 'Presque terminé...',
          emailPlaceholder: 'EMAIL',
          printed: 'IMPRESSION ...',
          print: 'IMPRIMER'
        });
        break;
      case 'nl':
        setTextDatas({
          description: 'Ontvang de foto per e-mail of scan de QR-code.',
          buttonDownload: 'Download de foto',
          buttonRetake: 'Hernoemen',
          buttonTake: 'Maak een foto',
          send: 'Verzenden',
          sendByEmail: 'Verzenden per e-mail',
          // <-- ajouté
          conditions: 'Ik ga akkoord met het ontvangen van de foto op mijn e-mailadres',
          conditions2: 'Ik heb de algemene voorwaarden gelezen en ga ermee akkoord.',
          sent: 'Foto verzonden!',
          look: 'Kijk naar de camera',
          preparingPhoto: 'Foto voorbereiden...',
          almostThere: 'Bijna klaar...',
          emailPlaceholder: 'EMAIL',
          printed: 'AFGEDRUKT',
          print: 'AFDRUKKEN'
        });
        break;
      case 'en':
        setTextDatas({
          description: 'Receive the photo by email or scan the QR code.',
          buttonDownload: 'Download Photo',
          buttonRetake: 'Retake Photo',
          buttonTake: 'Touch to start',
          send: 'Send',
          sendByEmail: 'Send by email',
          // <-- ajouté
          conditions: 'I agree to receive the photo at my email address',
          conditions2: 'I have read and agree to the terms and conditions.',
          sent: 'Photo sent!',
          look: 'Look at the camera',
          preparingPhoto: 'Preparing photo...',
          almostThere: 'Almost there...',
          emailPlaceholder: 'EMAIL',
          printed: 'PRINTED',
          print: 'PRINT'
        });
        break;
      case 'de':
        setTextDatas({
          description: 'Erhalten Sie das Foto per E-Mail oder scannen Sie den QR-Code.',
          buttonDownload: 'Foto herunterladen',
          buttonRetake: 'Foto erneut aufnehmen',
          buttonTake: 'Foto aufnehmen',
          send: 'Senden',
          sendByEmail: 'Per E-Mail senden',
          // <-- ajouté
          conditions: 'Ich stimme zu, das Foto an meine E-Mail-Adresse zu erhalten',
          conditions2: 'Ich habe die Allgemeinen Geschäftsbedingungen gelesen und akzeptiere sie.',
          sent: 'Foto gesendet!',
          look: 'Schau in die Kamera',
          preparingPhoto: 'Foto wird vorbereitet...',
          almostThere: 'Fast fertig...',
          emailPlaceholder: 'EMAIL',
          printed: 'GEDRUCKT',
          print: 'DRUCKEN'
        });
        break;
      case 'es':
        setTextDatas({
          description: 'Recibe la foto por correo electrónico o escanea el código QR.',
          buttonDownload: 'Descargar foto',
          buttonRetake: 'Volver a tomar la foto',
          buttonTake: 'Tomar foto',
          send: 'Enviar',
          sendByEmail: 'Enviar por correo',
          // <-- ajouté
          conditions: 'Acepto recibir la foto en mi dirección de correo electrónico',
          conditions2: 'He leído y acepto los términos y condiciones.',
          sent: '¡Foto enviada!',
          look: 'Mira a la cámara',
          preparingPhoto: 'Preparando foto...',
          almostThere: 'Casi listo...',
          emailPlaceholder: 'EMAIL',
          printed: 'IMPRESO',
          print: 'IMPRIMIR'
        });
        break;
      default:
        setTextDatas({
          description: 'Receive the photo by email or scan the QR code.',
          buttonDownload: 'Download Photo',
          buttonRetake: 'Retake Photo',
          buttonTake: 'Take Photo',
          send: 'Send',
          sendByEmail: 'Send by email',
          // <-- ajouté
          conditions: 'I agree to receive the photo at my email address',
          conditions2: 'I have read and agree to the terms and conditions.',
          sent: 'Photo sent!',
          look: 'Look at the camera',
          preparingPhoto: 'Preparing photo...',
          almostThere: 'Almost there...',
          emailPlaceholder: 'EMAIL',
          printed: 'PRINTED',
          print: 'PRINT'
        });
        break;
    }
  }, [intl.locale, defaultLanguage]);
  return /*#__PURE__*/_react.default.createElement(BackgroundWrapper, {
    style: {
      color: cell.text_color,
      fontFamily: font
    }
  }, /*#__PURE__*/_react.default.createElement(Container, null, (step === 'camera' || step === 'countdown') && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CameraContainer, {
    className: "camera-container",
    ref: cameraContainerRef,
    cameraReady: hasCamera,
    orientation: cell.orientation || 'portrait',
    aspectRatio: filterAspect
  }, /*#__PURE__*/_react.default.createElement(Camera, null, /*#__PURE__*/_react.default.createElement(VideoPreview, {
    ref: videoRef,
    autoPlay: true,
    playsInline: true,
    muted: true,
    mirror: true,
    orientation: cell.orientation || 'portrait',
    style: {
      display: hasCamera ? 'block' : 'none' // <--- invisible tant que pas prêt
    }
    // style={{ display: isProcessing && frozenFrame ? 'none' : 'block' }}
  }), /*#__PURE__*/_react.default.createElement(GifOverlay, {
    src: gif_uri_transformed,
    alt: "Frame overlay"
  }))), step === 'countdown' && /*#__PURE__*/_react.default.createElement(TopOverlay, null, countdown > 0 ? countdown > 3 ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(AnimatedArrows, {
    cell: cell,
    font: font,
    intl: intl,
    textDatas: textDatas
  }), /*#__PURE__*/_react.default.createElement(ButtonText, {
    style: {
      color: cell.text_color
    }
  }, textDatas.look)) : /*#__PURE__*/_react.default.createElement(CountdownOverlay, null, /*#__PURE__*/_react.default.createElement(CountdownNumber, null, countdown)) : isProcessing && /*#__PURE__*/_react.default.createElement(ProgressBarContainer, null, /*#__PURE__*/_react.default.createElement(ProgressText, null, processingProgress < 50 ? (0, _utils.i18nData)(cell, 'preparing_photo_text', intl, defaultLanguage) || textDatas.preparingPhoto || "Preparing photo..." : (0, _utils.i18nData)(cell, 'almost_there_text', intl, defaultLanguage) || textDatas.almostThere || "Almost there..."), /*#__PURE__*/_react.default.createElement(ProgressBarWrapper, null, /*#__PURE__*/_react.default.createElement(ProgressBarFill, {
    progress: processingProgress
  })))), step !== 'countdown' && /*#__PURE__*/_react.default.createElement(ControlBar, null, /*#__PURE__*/_react.default.createElement(CameraButton, {
    onClick: handleTakePhoto
  }, /*#__PURE__*/_react.default.createElement(ButtonText, {
    style: {
      color: cell.text_color
    }
  }, "  ", textDatas.buttonTake)))), step === 'share' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Preview, {
    step: step,
    style: {
      color: cell.text_color
    }
  }, /*#__PURE__*/_react.default.createElement(PreviewWrapper2, {
    id: "preview-wrapper"
  }, capturedPreview && /*#__PURE__*/_react.default.createElement("div", {
    id: "preview-wrapper",
    style: {
      position: 'relative',
      width: '100%',
      height: '100%',
      background: 'transparent',
      border: 'none',
      boxShadow: 'none',
      outline: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: capturedPreview,
    alt: "Preview avec rotation",
    crossOrigin: "anonymous",
    style: {
      display: 'block',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      border: 'none',
      boxShadow: 'none',
      outline: 'none'
    }
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: gif_uri_transformed,
    alt: "Cadre overlay",
    crossOrigin: "anonymous",
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none'
    }
  })))), /*#__PURE__*/_react.default.createElement(ShareOptionsContainer, null, cell.email && /*#__PURE__*/_react.default.createElement(EmailCard, {
    ref: emailCardRef
  }, /*#__PURE__*/_react.default.createElement(CardTitle, {
    color: "#ffffff"
  }, textDatas.sendByEmail), /*#__PURE__*/_react.default.createElement(EmailInput, {
    onClick: function onClick() {
      setKeyboardVisible(true);
    }
  }, email || (0, _utils.i18nData)(cell, 'email_placeholder_text', intl, defaultLanguage) || textDatas.emailPlaceholder || 'EMAIL'), /*#__PURE__*/_react.default.createElement(SendButton, {
    style: {
      background: cell.button_retake_background_color
    },
    onClick: function onClick(e) {
      if (isSending) return;
      e.preventDefault();
      e.stopPropagation();
      handleShare(e);
    },
    disabled: !email || !consent || isSending
  }, (0, _utils.i18nData)(cell, 'send', intl, defaultLanguage) || textDatas.send), isSended && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: 'green',
      fontSize: '0.8rem',
      marginTop: '0.5rem'
    }
  }, (0, _utils.i18nData)(cell, 'sent_text', intl, defaultLanguage) || textDatas.sent), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
      marginTop: '0.5rem',
      width: '90%'
    }
  }, /*#__PURE__*/_react.default.createElement(ShareCheckbox, {
    style: {
      fontFamily: font,
      fontSize: '0.5rem'
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    checked: consent,
    onChange: function onChange(e) {
      return setConsent(e.target.checked);
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: '#fff',
      fontFamily: font
    }
  }, textDatas.conditions)))), showQRCode && cell.qr_code && /*#__PURE__*/_react.default.createElement(QRCodeCard, {
    style: {
      background: cell.qr_card_background_color || 'rgba(122, 103, 66, 0.2)'
    }
  }, /*#__PURE__*/_react.default.createElement(CardTitle, {
    color: "#ffffff"
  }, textDatas.buttonDownload), /*#__PURE__*/_react.default.createElement(QRCodeDisplay, null, link ? /*#__PURE__*/_react.default.createElement(_qrcode.QRCodeSVG, {
    value: link,
    size: 120,
    bgColor: "transparent"
  }) : /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '120px',
      height: '120px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '60px',
      height: '60px',
      border: '4px solid rgba(122, 103, 66, 0.3)',
      borderTop: '4px solid #7A6742',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }
  }), /*#__PURE__*/_react.default.createElement("style", null, "\n                        @keyframes spin {\n                          0% { transform: rotate(0deg); }\n                          100% { transform: rotate(360deg); }\n                        }\n                      ")))), showPrint && cell.print && /*#__PURE__*/_react.default.createElement(PrintCard, {
    style: {
      background: cell.button_print_background_color || cell.button_retake_background_color
    },
    onClick: function onClick() {
      if (!capturedImage || printed) return;
      printImageData(capturedImage);
      setPrintButtonText(textDatas.printed);
    },
    disabled: printed
  }, /*#__PURE__*/_react.default.createElement(PrintIconContainer, null, /*#__PURE__*/_react.default.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "SVGRepo_bgCarrier",
    "stroke-width": "0"
  }), /*#__PURE__*/_react.default.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), /*#__PURE__*/_react.default.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 17.9827C4.44655 17.9359 3.51998 17.7626 2.87868 17.1213C2 16.2426 2 14.8284 2 12C2 9.17157 2 7.75736 2.87868 6.87868C3.75736 6 5.17157 6 8 6H16C18.8284 6 20.2426 6 21.1213 6.87868C22 7.75736 22 9.17157 22 12C22 14.8284 22 16.2426 21.1213 17.1213C20.48 17.7626 19.5535 17.9359 18 17.9827",
    stroke: "white",
    "stroke-width": "1.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 10H6",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 14L5 14",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.1213 2.87868L16.591 3.40901V3.40901L17.1213 2.87868ZM6.87868 2.87868L7.40901 3.40901V3.40901L6.87868 2.87868ZM6.87868 21.1213L7.40901 20.591H7.40901L6.87868 21.1213ZM18.75 14C18.75 13.5858 18.4142 13.25 18 13.25C17.5858 13.25 17.25 13.5858 17.25 14H18.75ZM6.75 14C6.75 13.5858 6.41421 13.25 6 13.25C5.58579 13.25 5.25 13.5858 5.25 14H6.75ZM17.25 16C17.25 17.4354 17.2484 18.4365 17.1469 19.1919C17.0482 19.9257 16.8678 20.3142 16.591 20.591L17.6517 21.6517C18.2536 21.0497 18.5125 20.2919 18.6335 19.3918C18.7516 18.5132 18.75 17.393 18.75 16H17.25ZM12 22.75C13.393 22.75 14.5132 22.7516 15.3918 22.6335C16.2919 22.5125 17.0497 22.2536 17.6517 21.6517L16.591 20.591C16.3142 20.8678 15.9257 21.0482 15.1919 21.1469C14.4365 21.2484 13.4354 21.25 12 21.25V22.75ZM12 2.75C13.4354 2.75 14.4365 2.75159 15.1919 2.85315C15.9257 2.9518 16.3142 3.13225 16.591 3.40901L17.6517 2.34835C17.0497 1.74643 16.2919 1.48754 15.3918 1.36652C14.5132 1.24841 13.393 1.25 12 1.25V2.75ZM12 1.25C10.607 1.25 9.48678 1.24841 8.60825 1.36652C7.70814 1.48754 6.95027 1.74643 6.34835 2.34835L7.40901 3.40901C7.68577 3.13225 8.07434 2.9518 8.80812 2.85315C9.56347 2.75159 10.5646 2.75 12 2.75V1.25ZM5.25 16C5.25 17.393 5.24841 18.5132 5.36652 19.3918C5.48754 20.2919 5.74643 21.0497 6.34835 21.6517L7.40901 20.591C7.13225 20.3142 6.9518 19.9257 6.85315 19.1919C6.75159 18.4365 6.75 17.4354 6.75 16H5.25ZM12 21.25C10.5646 21.25 9.56347 21.2484 8.80812 21.1469C8.07435 21.0482 7.68577 20.8678 7.40901 20.591L6.34835 21.6517C6.95027 22.2536 7.70814 22.5125 8.60825 22.6335C9.48678 22.7516 10.607 22.75 12 22.75V21.25ZM18.7323 5.97741C18.6859 4.43521 18.5237 3.22037 17.6517 2.34835L16.591 3.40901C17.0016 3.8196 17.1859 4.4579 17.233 6.02259L18.7323 5.97741ZM6.76698 6.02259C6.81413 4.4579 6.99842 3.8196 7.40901 3.40901L6.34835 2.34835C5.47633 3.22037 5.31413 4.43521 5.26766 5.97741L6.76698 6.02259ZM18.75 16V14H17.25V16H18.75ZM6.75 16V14H5.25V16H6.75Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "17",
    cy: "10",
    r: "1",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15 16.5H9",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 19H9",
    stroke: "white",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  })))), /*#__PURE__*/_react.default.createElement(PrintButton, null, printed ? (0, _utils.i18nData)(cell, 'printed_text', intl, defaultLanguage) || textDatas.printed || 'PRINTED' : (0, _utils.i18nData)(cell, 'print_text', intl, defaultLanguage) || textDatas.print || 'PRINT'))), /*#__PURE__*/_react.default.createElement(ButtonGroup, null, /*#__PURE__*/_react.default.createElement(SecondaryButton, {
    style: {
      background: cell.button_retake_background_color,
      color: cell.button_retake_text_color,
      border: "0.3em solid ".concat(cell.button_retake_border_color || '#FFFFFF')
    },
    onClick: handleRetake
  }, (0, _utils.i18nData)(cell, 'button_retake_text', intl, defaultLanguage) || textDatas.buttonRetake)), keyboardVisible && cell.email && /*#__PURE__*/_react.default.createElement(_AzertyKeyboard.default, {
    field_name: 'Email',
    setVisible: setKeyboardVisible,
    project: project,
    input: email,
    setInput: setEmail,
    anchorRef: emailCardRef
  })), /*#__PURE__*/_react.default.createElement("canvas", {
    ref: previewCanvasRef,
    width: 1252,
    height: 1800,
    style: {
      display: 'none',
      width: '1252px',
      height: '1800px'
    }
  })));
}
function AnimatedArrows(_ref57) {
  var cell = _ref57.cell;
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "70",
    height: "80",
    viewBox: "0 0 24 48"
  }, /*#__PURE__*/_react.default.createElement("style", null, "\n            .moveUp {\n              animation: moveUp 0.8s ease-in-out infinite alternate;\n              transform-origin: 50% 50%;\n              transform-box: fill-box;\n            }\n\n            @keyframes moveUp {\n              0% { transform: translateY(0); }\n              100% { transform: translateY(-6px); }\n            }\n          "), /*#__PURE__*/_react.default.createElement("g", {
    className: "moveUp"
  }, /*#__PURE__*/_react.default.createElement("polyline", {
    points: "5 10 12 3 19 10",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("polyline", {
    points: "5 20 12 13 19 20",
    fill: "none",
    stroke: "#bbbbbb",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("polyline", {
    points: "5 30 12 23 19 30",
    fill: "none",
    stroke: "#333333",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}